module.exports = __webpack_public_path__ + "static/img/1.1d0f2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/1.png
// module id = PbQI
// module chunks = 0